export default "__VITE_ASSET__CCP5WVQr__"